import React from 'react';
//mport {useMutation, useNotify, Button } from 'react-admin';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToCreate = ({ classes, ...props}) => {

    var name = (props && props.name)? props.name : 'Create';
    var path = (props && props.path)? props.path : '';
    var id = (props && props.id)? props.id : '';
    var serial_num = (props && props.serial_num)? props.serial_num : '';
   // console.log(props);
    
    return <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: path,
            ins_id: id,
            serial_num: serial_num
        }}
        className={classes.link}
       
    >
        <AddCircleIcon className={classes.icon} />{name}
    </Button>
};


export default  withStyles(styles)(LinkToCreate);   